import { render, staticRenderFns } from "./CompanyAuthorisedSignatory.vue?vue&type=template&id=fcedaa06&scoped=true&"
import script from "./CompanyAuthorisedSignatory.vue?vue&type=script&lang=ts&"
export * from "./CompanyAuthorisedSignatory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcedaa06",
  null
  
)

export default component.exports